/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-06-15 09:27:20
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-16 09:32:47
 * @FilePath: \djymap\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
